import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions/index";
import withLoading from "../../../hoc/Loading/Loading";
import "./survey-quiz.css";
import "./survey-quiz-mobile.css";
import SurveyWelcomeBlock from "./TriviaWelcomeBlock";
import MessagingSurvey from "./MessaginSurvey";
import SurveyQuestionsBlock from "./TriviaQuestionBlock";
import SurveyEndingBlock from "./TriviaEndingBlock";
import {
  applyCustomFontStyles,
  getSourceStringfromResponse,
  getThemeSettingsForPage,
  getTriviaFileName,
  isAnswerChanged,
  isTrivvyGeneratedFromCustomTemplates,
  noScoreTrivvy,
  THEME_SETTING,
  trivvyFromCustomTemplates,
} from "../data";
import { BiArrowBack, BiSkipNext, BiSkipPrevious, BiX } from "react-icons/bi";
import ReactTooltip from "react-tooltip";
import { Button } from "reactstrap";
import EmptyTable from "../../../components/EmptyTable/EmptyTable";
import {
  baseUrl,
  formatQuestionsNumberWise,
  reorderQuestions,
} from "../../../utils/constants";
import moment from "moment";
import { toastContainer } from "../../../utils/toast";
import { isMobile } from "../../../utils/deviceInfo";
import { AiFillClockCircle } from "react-icons/ai";
import trivvyAccessDenied from "../../../assets/trivvy/denied_state.png";
import trivvyDraft from "../../../assets/trivvy/trivvy-draft.png";
import TriviaRatingBlock from "../Components/TriviaRatingBlock";
function TriviaQuizUI({
  surveyId,
  setCurrentQuiz,
  quizData,
  setCurrentQuestion,
  setCurrentQuizQuestion,
  currentQuestion,
  currentQuizQuestion,
  triviaResponses,
  updateTriviaResponses,
  resetTrivia,
  previewOnly,
  togglePreview,
  quizResultObjectId,
  setCurrentQuizResultObjectId,
  isOpenQuiz,
  quizExternalUserData,
  setCurrentQuizExternalUserdata,
  demoPreview,
  view,
  currentQuizLinkedRewards,
  setCurrentQuizLinkedRewards,
  setTrivvyRatingSubmitted,
  ratingSubmitted,

  ...props
}) {

  setCurrentQuestion = demoPreview
    ? setCurrentQuestion
    : setCurrentQuizQuestion;
  currentQuestion = demoPreview ? currentQuestion : currentQuizQuestion;

  const [apiErrorMessage, setApiErrorMessage] = useState(null);
  const [endDateDue, setEndDateDue] = useState(false);
  const [apiErrorImage, setApiErrorImage] = useState(null);


  const [timeTaken, setTimeTaken] = useState(0);
  // const [linkedRewards, setLinkedRewards] = useState([]);
  const [quizResult, setQuizResult] = useState({
    correct: 0,
    total: 0,
    correct_array: [],
    wrong_array: [],
  });

  console.log(props.user,'user here')
  const isMobileView = demoPreview ? view == "MOBILE" : isMobile;

  const totalQuizMins = 1;
  const isMessaging=quizData && quizData.isMessaging

  const isNonMcqTrivvy = quizData && 
  quizData.questions && Array.isArray(quizData.questions) ?
  quizData.questions.filter(
    (x) =>
      x.question_type == "MCQ" && x.correct_options && x.correct_options[0]
  ).length == 0 : false

  const getQuizSeconds = mins => {
    if (quizData && quizData.questions) {
      let validQuestions = quizData.questions.filter(
        x => x.question_type == "MCQ" && x.correct_options && x.correct_options[0] && x.correct_options[0].text
      );

      let otherQuestions = quizData.questions.filter(
        x => x.question_type == "TEXT" || x.question_type == "LINEAR_NUMERIC"
      );

      // if (trivvyFromCustomTemplates(quizData)) {
      //   return 0;
      // }

      

      if (validQuestions.length >= 3) {
        return mins * 60;
      } else {
        return 20 * validQuestions.length;
      }
    }
  };

  const ifMixedTimedMcqTrivvy=()=>{
    if (quizData && quizData.questions) {
    let validQuestions = quizData.questions.filter(
      x => x.question_type == "MCQ"
    );

    let otherQuestions = quizData.questions.filter(
      x => x.question_type == "TEXT" || x.question_type == "LINEAR_NUMERIC"
    );

    if (validQuestions.length && otherQuestions.length) {
      return true;
    }
  }
  return false
  }

  const totalQuizSeconds = getQuizSeconds(totalQuizMins);

  const isMixedTimedMcqTrivvy = ifMixedTimedMcqTrivvy()
  const [loading, setLoading] = useState(false);
  const [startButtonLoading, setStartButtonLoading] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [autoStarting, setAutoStarting] = useState(false);
  const [allowAttempts, setAllowAttempts] = useState(null);

  // Track if component is mounted to prevent state updates on unmounted component
  const isMountedRef = useRef(true);

  const getData = () => {
    const paramBlock = demoPreview ? "start" : props.match.params.block;
    setLoading(true);
    if (paramBlock === "start") {
      let apiUrl = url.getTriviaForQuiz(surveyId);

      if (previewOnly) {
        apiUrl = url.getTriviaForEdit(surveyId, false);
      }

      if (isOpenQuiz) {
        apiUrl = url.getTriviaForQuizExtrenalUser(surveyId);
      }

      axios
        .get(apiUrl)
        .then(({ data }) => {
          console.log('data -- ', data.data)
          const trivia = {
            ...data.data.trivia,
          };

          if (trivia.randomizeQuestions) {
            trivia.questions = reorderQuestions(trivia.questions);
          }

          trivia.questions = formatQuestionsNumberWise(trivia.questions);

          if (demoPreview || previewOnly) {
            setLoading(false);
            setCurrentQuiz({ ...trivia });
            setCurrentQuizLinkedRewards(data.data.linkedRewards || []);

            if (!currentQuestion || paramBlock === "start") {
                setCurrentQuestion("WELCOME");
            }
          } else {
            const endDateCheck =
              trivia.trivvyEndDate &&
              !moment(trivia.trivvyEndDate).startOf("day")
                .isSameOrBefore(moment(),"day");

            const publishCheck = trivia.isPublished;
            if (trivia.trivvyEndDate && !endDateCheck) {
              setLoading(false);
              setCurrentQuiz({ ...trivia, orgPlan: data.data.orgPlan });
              setEndDateDue(true);
            if (!currentQuestion || paramBlock === "start") {
                setCurrentQuestion("WELCOME");
            }
            } else if (!publishCheck) {
              setLoading(false);
              setCurrentQuiz(null);
              setApiErrorMessage(`Sorry. This trivvy is not published yet.`);
              setApiErrorImage(trivvyDraft);
            } else {
              setLoading(false);
              setCurrentQuiz(trivia);
              setAllowAttempts(trivia.allowAttempts);
              setCurrentQuizLinkedRewards(data.data.linkedRewards || []);
              if (!currentQuestion || paramBlock === "start") {
                // For messaging trivvys, show loading immediately for logged-in users
                if (props.user && props.user._id && !isOpenQuiz && !previewOnly && !demoPreview && isMessaging) {
                  setAutoStarting(true);
                } else {
                  setCurrentQuestion("WELCOME");
                }
              }
            }
          }
        })
        .catch(error => {
          setLoading(false);
          setCurrentQuiz(null);
          setApiErrorImage(trivvyAccessDenied);
          setCurrentQuizLinkedRewards([]);
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            setApiErrorMessage(error.response.data.errors.message);
          }
          console.log(error);
        });
    }
  };
  useEffect(() => {
    if (surveyId) {
      getData();
    }
  }, [surveyId]);

  console.log(props.user, "props.user");

  // const handleWindowClose = () => {
    // if(currentQuestion && currentQuestion.question_id){

  
    // const pResponses = triviaResponses;

    

    // let totalTimeTakenForMCQs = 0;
    // let totalOverallTime = 0;
    // let totalCorrect = 0,
    //   totalWrong = 0;

    // for (const response of pResponses) {
    //   totalOverallTime += response.timeTaken;
    //   if (response.question_type == "MCQ") {
    //     totalTimeTakenForMCQs += response.timeTaken;
    //   } else {
    //     if (isNonMcqTrivvy) {
    //       totalTimeTakenForMCQs += response.timeTaken;
    //     }
    //   }
    //   if (
    //     response.question.correct_options &&
    //     response.question.correct_options.find(
    //       x => x.option_id === response.selectedAnswer && response.selectedAnswer.option_id
    //     )
    //   ) {
    //     totalCorrect += 1;
    //   } else {
    //     if (response.question_type == "MCQ") {
    //       totalWrong += 1;
    //     }
    //   }
    // }

    

    // if (noScoreTrivvy(quizData)) {
    //   totalCorrect = 0;
    //   totalWrong = 0;
    // }


    //   const url_cond = isOpenQuiz
    //     ? url.storeDropoffsGuest(quizResultObjectId)
    //     : url.storeDropoffs(quizResultObjectId);
    
    
    //     axios
    //     .post(url_cond, {
    //       objectId:quizResultObjectId,
    //       isNonMcqTrivvy,
    //       responsesCount: pResponses.length,
    //       totalCorrect: totalCorrect,
    //       totalWrong: totalWrong,
    //       totalQuestions: quizData.questions.filter(
    //         x => x.question_type == "MCQ"
    //       ).length,
    //       completion:
    //         (triviaResponses.filter(x => x.selectedAnswer).length / quizData.questions.length) * 100,
    //       totalTime: totalTimeTakenForMCQs,
    //       totalOverallTime: totalOverallTime,
    //       responses: pResponses.map(x => ({
    //         question_id: x.question_id,
    //         timeTaken: x.timeTaken,
    //         selected_answers:x.selectedAnswer == null ? []:
    //           typeof x.selectedAnswer == "string"
    //             ? [{ text: JSON.stringify(x.selectedAnswer) }]
    //             : [x.selectedAnswer],
    //         question_type: x.question_type,
    //         source: getSourceStringfromResponse(x)
    //       })),
    //       responseOrgId: props && props.match && props.match.params ? props.match.params.orgId:quizData.organizationId,
    //       triviaId: quizData._id,
    //       // triviaCreatedBy: quizData.createdBy._id,
    //       userData: {
    //         email: quizExternalUserData ? quizExternalUserData.email : null,
    //         name: quizExternalUserData ? quizExternalUserData.name : null,
    //         employeeId: quizExternalUserData
    //           ? quizExternalUserData.employeeId
    //           : null,
    //       },
    //     })
    //     .then(res => {
    //       //resetTrivia();
    //       const urlCondq = !isOpenQuiz
    //         ? url.writeCurrentTriviaTopScores
    //         : url.writeCurrentTriviaTopScoresPublic;
    //       axios
    //         .post(urlCondq, {
    //           triviaId: quizData._id,
    //         })
    //         .then(res => {
    //           console.log("Top scores updated successfully");
    //         })
    //         .catch(err => {
    //           console.log("Error while writing top scores");
    //         });
    //     });
    
    //   }

  // };





  const handleWindowClose = () => {
    if (currentQuestion && currentQuestion.question_id) {
      const pResponses = triviaResponses;
  
      let totalTimeTakenForMCQs = 0;
      let totalOverallTime = 0;
      let totalCorrect = 0, totalWrong = 0;
  
      for (const response of pResponses) {
        totalOverallTime += response.timeTaken;
        if (response.question_type == "MCQ") {
          totalTimeTakenForMCQs += response.timeTaken;
        } else {
          if (isNonMcqTrivvy) {
            totalTimeTakenForMCQs += response.timeTaken;
          }
        }
        if (
          response.question.correct_options &&
          response.question.correct_options.find(
            x =>
              x.option_id === response.selectedAnswer &&
              response.selectedAnswer.option_id
          )
        ) {
          totalCorrect += 1;
        } else {
          if (response.question_type == "MCQ") {
            totalWrong += 1;
          }
        }
      }
  
      if (noScoreTrivvy(quizData)) {
        totalCorrect = 0;
        totalWrong = 0;
      }
  
      // ✅ define url_cond BEFORE using it
      const url_cond = isOpenQuiz
        ? url.storeDropoffsGuest(quizResultObjectId)
        : url.storeDropoffs(quizResultObjectId);
  
      // build the SAME payload you already send
      const payload = {
        objectId: quizResultObjectId, // you had this in some versions; keep it if needed
        isNonMcqTrivvy,
        responsesCount: pResponses.length,
        totalCorrect: totalCorrect,
        totalWrong: totalWrong,
        totalQuestions: quizData.questions.filter(x => x.question_type == "MCQ").length,
        completion:
          (triviaResponses.filter(x => x.selectedAnswer).length / quizData.questions.length) * 100,
        totalTime: totalTimeTakenForMCQs,
        totalOverallTime: totalOverallTime,
        responses: pResponses.map(x => ({
          question_id: x.question_id,
          timeTaken: x.timeTaken,
          selected_answers:
            x.selectedAnswer == null
              ? []
              : typeof x.selectedAnswer == "string"
              ? [{ text: JSON.stringify(x.selectedAnswer) }]
              : [x.selectedAnswer],
          question_type: x.question_type,
          source: getSourceStringfromResponse(x),
        })),
        responseOrgId:
          (props && props.match && props.match.params
            ? props.match.params.orgId
            : quizData.organizationId),
        triviaId: quizData._id,
        userData: {
          email: quizExternalUserData ? quizExternalUserData.email : null,
          name: quizExternalUserData ? quizExternalUserData.name : null,
          employeeId: quizExternalUserData ? quizExternalUserData.employeeId : null,
        },
      };
  
      // Best-effort fire-and-forget BEFORE axios (doesn't block)
      try {
        if (navigator && typeof navigator.sendBeacon === "function") {
          const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
          navigator.sendBeacon(url_cond, blob);
        }
      } catch (_) {}
  
      // Keep your original axios flow exactly as-is
      axios
        .post(url_cond, payload)
        .then(res => {
          const urlCondq = !isOpenQuiz
            ? url.writeCurrentTriviaTopScores
            : url.writeCurrentTriviaTopScoresPublic;
  
          // optional best-effort for the second call too
          try {
            if (navigator && typeof navigator.sendBeacon === "function") {
              const blob2 = new Blob([JSON.stringify({ triviaId: quizData._id })], {
                type: "application/json",
              });
              navigator.sendBeacon(urlCondq, blob2);
            }
          } catch (_) {}
  
          return axios
            .post(urlCondq, { triviaId: quizData._id })
            .then(() => {
              console.log("Top scores updated successfully");
            })
            .catch(() => {
              console.log("Error while writing top scores");
            });
        });
    }
  };
  



  
  // useEffect(() => {

  //   window.addEventListener('beforeunload', handleWindowClose);


  //   return () => {
  //     window.removeEventListener('beforeunload', handleWindowClose);
  //   };
  // }, [triviaResponses]);

  // useEffect(() => {
  //   // keep your existing one
  //   window.addEventListener('beforeunload', handleWindowClose);
  
  //   // add these two:
  //   const onPageHide = (e) => {
  //     // ignore BFCache restore, but still send on normal hides
  //     if (e && e.persisted) return;
  //     handleWindowClose();
  //   };
  //   const onVisibilityChange = () => {
  //     if (document.visibilityState === 'hidden') {
  //       handleWindowClose();
  //     }
  //   };
  //   window.addEventListener('pagehide', onPageHide);
  //   document.addEventListener('visibilitychange', onVisibilityChange);
  
  //   return () => {
  //     window.removeEventListener('beforeunload', handleWindowClose);
  //     window.removeEventListener('pagehide', onPageHide);
  //     document.removeEventListener('visibilitychange', onVisibilityChange);
  //   };
  // }, [triviaResponses]); // keep your dependency as-is
  
// 1) keep the handler as you wrote it — do not change it

// 2) stable ref to the latest handler
// const handleWindowCloseRef = React.useRef(handleWindowClose);
// useEffect(() => {
//   handleWindowCloseRef.current = handleWindowClose;
// }, [handleWindowClose]); // safe: react will update when your handler identity changes

// // tiny helper so we always call the latest
// const runCloseHandler = React.useCallback(() => {
//   try { handleWindowCloseRef.current && handleWindowCloseRef.current(); } catch (_) {}
// }, []);

const handleWindowCloseRef = useRef(handleWindowClose);
useEffect(() => {
  handleWindowCloseRef.current = handleWindowClose;
}, [triviaResponses, quizData, currentQuestion, quizExternalUserData, isOpenQuiz, quizResultObjectId]);




// 3) register robust close signals ONCE
useEffect(() => {
  const run = () => {
    try { handleWindowCloseRef.current && handleWindowCloseRef.current(); } catch (e) {}
  };

  // Fire on tab close/reload (and show native prompt consistently)
  const onBeforeUnload = (e) => {
    run();
    // ensure prompt shows (many browsers require setting returnValue)
    e.preventDefault();
    e.returnValue = '';
  };

  // Fire on mobile/iOS Safari and normal hides (not BFCache restores)
  const onPageHide = (e) => {
    if (e && e.persisted) return;
    run();
  };

  // Fire when tab goes background / becomes hidden
  const onVisibilityChange = () => {
    if (document.visibilityState === 'hidden') run();
  };

  window.addEventListener('beforeunload', onBeforeUnload);
  window.addEventListener('pagehide', onPageHide);
  document.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    window.removeEventListener('beforeunload', onBeforeUnload);
    window.removeEventListener('pagehide', onPageHide);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
}, []);



  useEffect(() => {
    const param = demoPreview ? "start" : props.match.params.block;

    if (param === "start") {
      console.log("Frommm ---- ", currentQuestion);
      if (!previewOnly && currentQuestion && currentQuestion.question_id) {
        //dont show start page
      } else {
        setCurrentQuizExternalUserdata(null);
        //if (!demoPreview) {
        resetTrivia();
        //}

        getData();
      }
    }
  }, [props.match && props.match.params]);



  // Handle messaging auto-start: transition from loading to messaging component
  useEffect(() => {
    if (autoStarting && quizData && isMessaging && isMountedRef.current) {
      setAutoStarting(false);
      setCurrentQuestion("MESSAGING");
    }
  }, [autoStarting, quizData, isMessaging]);

  // Cleanup function to prevent memory leaks
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    const param = demoPreview ? "start" : props.match.params.block;
    if (param == "result") {
      const urlParams = new URLSearchParams(window.location.search);
      const resultId = urlParams.get("resultId");
      if (resultId) {
        setLoading(true);
        axios.get(url.getTrivvyResultById(resultId)).then(({ data }) => {
          console.log("resultt---", data.data);
          setLoading(false);
          const trivvy = { ...data.data.triviaId };
          const result = { ...data.data, triviaId: trivvy._id };
          setCurrentQuiz(trivvy);
          setCurrentQuestion("ENDING");
          setCurrentQuizResultObjectId(result._id);
          const redResponses = result.responses.map(x => ({
            question_id: x.question_id,
            selectedAnswer: x.selected_answers[0],
            question_type: x.question_type,
            question: trivvy.questions.find(
              y => y.question_id == x.question_id
            ),
          }));

          console.log(redResponses);

          updateTriviaResponses(redResponses);
        }).catch((error) => {
          setLoading(false);
          console.error("Error loading result:", error);
        });
      }
    }
  }, [props.match.params.block]);


  


  // Put this inside jumpToNextStep, before axios.post(...):
  const finishLastQuestion = (pResponsesLocal) => {
    let totalTimeTakenForMCQs = 0;
  let totalOverallTime = 0;
  let totalCorrect = 0, totalWrong = 0;

  console.log("AAAA", pResponsesLocal.length);

  for (const response of pResponsesLocal) {
    totalOverallTime += response.timeTaken;
    if (response.question_type == "MCQ") {
      totalTimeTakenForMCQs += response.timeTaken;
    } else {
      if (isNonMcqTrivvy) {
        totalTimeTakenForMCQs += response.timeTaken;
      }
    }
    if (
      response.selectedAnswer &&
      response.question.correct_options &&
      response.question.correct_options.find(
        x => x.option_id === response.selectedAnswer.option_id
      )
    ) {
      totalCorrect += 1;
    } else {
      if (response.question_type == "MCQ" && response.question.correct_options && response.question.correct_options[0]) {
        totalWrong += 1;
      }
    }
  }

  if (noScoreTrivvy(quizData)) {
    console.log("nonloop");
    totalCorrect = 0;
    totalWrong = 0;
  }

  setTimeTaken(totalTimeTakenForMCQs);

  setQuizResult({
    correct: totalCorrect,
    total: quizData.questions && quizData.questions.length,
  });


  if (quizData.ratingPage && quizData.ratingPage.display) {
    setCurrentQuestion("RATING");
    if (!demoPreview) {
      props.history.push("rating");
    }
  } else {
    if (!demoPreview) {
      props.history.push({
        pathname: "result",
        search: `?resultId=${quizResultObjectId}`,
      });
    }
    setCurrentQuestion("ENDING");
  }
};




  const jumpToNextStep = (index,pResponses=triviaResponses) => {
    let isAnonymous = quizData.isAnonymous

    let isLastQuestion =
      quizData.questions && quizData.questions.length - 1 === index - 1;

    const isFirstStep = index == 0;

    if (isFirstStep && previewOnly) {
      const doc = quizData.questions[index];

      if (!demoPreview) {
        props.history.push(doc.question_id);
      }

      setCurrentQuestion(doc);
    }

    if (isFirstStep && !previewOnly) {
      const url_cond = isOpenQuiz
        ? url.addTriviaResponseForGuest
        : url.addTriviaResponse;

      const medium = new URLSearchParams(window.location.search).get("medium")

      setStartButtonLoading(true);
      axios
        .post(url_cond, {
          isAnonymous: isAnonymous,
          surveyId: quizData._id,
          responsesCount: 0,
          isOpenQuiz: isOpenQuiz,
          userData: {
            email: quizExternalUserData ? quizExternalUserData.email : null,
            name: quizExternalUserData ? quizExternalUserData.name : null,
            mobileNumber: quizExternalUserData ? quizExternalUserData.mobileNumber : null,
            employeeId: quizExternalUserData
              ? quizExternalUserData.employeeId
              : null,
            firstName: quizExternalUserData ? quizExternalUserData.firstName : null,
            lastName: quizExternalUserData ? quizExternalUserData.lastName : null,
          },
          orgId: props.match.params.orgId,
          ...(quizData.createdBy &&
            quizData.createdBy._id && {
              triviaCreatedBy: {
                userId: quizData.createdBy._id,
                firstName: quizData.createdBy.firstName,
                lastName: quizData.createdBy.lastName,
                profilePic: quizData.createdBy.profilePic,
              },
            }),
            ...(isOpenQuiz && {
                shareLinkMedium:medium
            })
        })
        .then(res => {
          // console.log('data.data.doc  -- ', res.data.data )
          // if questions answered previously
          // let newIndex=0
          if(res.data.data && res.data.data.doc && res.data.data.doc.totalQuestions && res.data.data.doc.totalQuestions>0){
            index = res.data.data.doc.totalQuestions
            console.log('res.data.data.doc --- ', res.data.data.doc)
          }
          console.log('608index -- ', index)
          if(index == quizData.questions.length){
            index = quizData.questions.length-1
            console.log('611index -- ', index)
          }

          isLastQuestion = index == quizData.questions.length
          console.log('is lastquestio n--- ', isLastQuestion)


          let allResponses = res.data.data.doc.responses.map(x => ({
            question_id: x.question_id,
            selectedAnswer: x.selected_answers[0],
            question_type: x.question_type,
            question: quizData.questions.find(
              y => y.question_id == x.question_id
            ),
          }));

          console.log(allResponses);

          updateTriviaResponses(allResponses)

          if ((!props.user || !props.user._id) && res.data.data.doc.totalQuestions == quizData.questions.length) {
              index = 0;
          }

          if (res.data.data.doc.attemptNumber > 0 && allowAttempts === 0 && quizData.uploadType !== null && quizData.uploadType !== undefined) {
            setStartButtonLoading(false);
            toastContainer("You have already responded. Retakes are not allowed on this Trivvy.", "error");
            return;
          }

        if(!isLastQuestion){
          setStartButtonLoading(false);
          setStartTime(new Date());
          const doc = quizData.questions[index];
          props.history.push(doc.question_id);


          setCurrentQuestion(doc);
          setCurrentQuizResultObjectId(res.data.data.doc._id);
          setCurrentQuiz({
            ...quizData,
            isLastAttempt: res.data.data.isLastAttempt,
            trivvyOrgPlan: res.data.data.trivvyPlanType,
          });
        }  else { 
          // ensure result id is set before finishing (matches your existing flow)
          // setCurrentQuizResultObjectId(res.data.data.doc._id);
          // // run the exact same last-question logic now
          // finishLastQuestion(pResponses);
          
          setCurrentQuiz({
            ...quizData,
            isLastAttempt: res.data.data.isLastAttempt,
            trivvyOrgPlan: res.data.data.trivvyPlanType,
          });

          let allResponses = res.data.data.doc.responses.map(x => ({
            question_id: x.question_id,
            selectedAnswer: x.selected_answers[0],
            question_type: x.question_type,
            question: quizData.questions.find(
              y => y.question_id == x.question_id
            ),
          }));

          console.log(allResponses);

          updateTriviaResponses(allResponses)

          finishLastQuestion(pResponses)

            // if (quizData.ratingPage && quizData.ratingPage.display) {
            //   setCurrentQuestion("RATING");
            //   if (!demoPreview) {
            //     props.history.push("rating");
            //   }
            // } else {
            //   if (!demoPreview) {
            //     props.history.push({
            //       pathname: "result",
            //       search: `?resultId=${quizResultObjectId}`,
            //     });
            //   }
            //   setCurrentQuestion("ENDING");
            // }

            return;
          }
        })
        .catch(error => {
          setStartButtonLoading(false);
          const message =
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message;
          if (message) {
            if (message == "ATTEMPT_EXCEED") {
              toastContainer(
                "Sorry, You have exceeded the attempt limit of trivvy",
                "error"
              );
            } else if (
              message.indexOf("You have passed the trivvy already") >= 0
            ) {
              toastContainer(message, "error");
            } else if (
              message.indexOf(
                "You are not allowed to take this trivvy isnt shared with you"
              ) >= 0
            ) {
              toastContainer(message, "error");
            } 
            else if (message.indexOf("The trivvy is not published") >= 0) {
              toastContainer(message, "error");
            }
            else if (message.indexOf("You already attempted this Trivvy and you are not allowed to take it again") >= 0) {
              toastContainer(message, "error");
            }
             else {
              toastContainer(
                "You can’t take the same Trivvy more than once",
                "error"
              );
            }
          }
          console.log(error);
        });
    }
    if (index > 0) {
      if (isLastQuestion) {
        // finishLastQuestion(pResponses);
        let totalTimeTakenForMCQs = 0;
        let totalOverallTime = 0;
        let totalCorrect = 0,
          totalWrong = 0;

          console.log("AAAA",pResponses.length)

        for (const response of pResponses) {
          totalOverallTime += response.timeTaken;
          if (response.question_type == "MCQ") {
            totalTimeTakenForMCQs += response.timeTaken;
          } else {
            if (isNonMcqTrivvy) {
              totalTimeTakenForMCQs += response.timeTaken;
            }
          }
          if (
            response.selectedAnswer &&
            response.question.correct_options &&
            response.question.correct_options.find(
              x => x.option_id === response.selectedAnswer.option_id
            )
          ) {
           
            totalCorrect += 1;
          } else {
            if (response.question_type == "MCQ" && response.question.correct_options && response.question.correct_options[0]) {

              totalWrong += 1;
            }
          }
        }

        if (noScoreTrivvy(quizData)) {
          console.log("nonloop")
          totalCorrect = 0;
          totalWrong = 0;
        }

        // const endTime = moment();

        // const timeDiff = moment(endTime).diff(startTime, "seconds");

        setTimeTaken(totalTimeTakenForMCQs);

        setQuizResult({
          correct: totalCorrect,
          total: quizData.questions && quizData.questions.length,
        });



        if (!previewOnly) {

          

          const url_cond = isOpenQuiz
            ? url.submitTriviaResponseForGuest(quizResultObjectId)
            : url.submitTriviaResponse(quizResultObjectId);
          axios
            .post(url_cond, {
              isAnonymous: isAnonymous,
              isNonMcqTrivvy,
              responsesCount: pResponses.length,
              totalCorrect: totalCorrect,
              totalWrong: totalWrong,
              totalQuestions: quizData.questions.filter(
                x => x.question_type == "MCQ" && x.correct_options && x.correct_options[0]
              ).length,
              completion:
                (triviaResponses.filter(x => x.selectedAnswer).length / quizData.questions.length) * 100,
              totalTime: totalTimeTakenForMCQs,
              totalOverallTime: totalOverallTime,
              responses: pResponses.map(x => ({
                question_id: x.question_id,
                timeTaken: x.timeTaken,
                selected_answers:x.selectedAnswer == null ? []:
                  typeof x.selectedAnswer == "string"
                    ? [{ text: JSON.stringify(x.selectedAnswer) }]
                    : [x.selectedAnswer],
                question_type: x.question_type,
                source:getSourceStringfromResponse(x)
              })),
              responseOrgId: props && props.match && props.match.params ? props.match.params.orgId:quizData.organizationId,
              triviaId: quizData._id,
              // triviaCreatedBy: quizData.createdBy._id,
              userData: {
                email: quizExternalUserData ? quizExternalUserData.email : null,
                name: quizExternalUserData ? quizExternalUserData.name : null,
                mobileNumber: quizExternalUserData ? quizExternalUserData.mobileNumber : null,
                firstName: quizExternalUserData ? quizExternalUserData.firstName : null,
                lastName: quizExternalUserData ? quizExternalUserData.lastName : null,
                employeeId: quizExternalUserData
                  ? quizExternalUserData.employeeId
                  : null,
                
              },
              
             
            })
            .then(res => {

              console.log('619 res.data.data.doc --- ', res.data.data)


              if(res && res.data.data && res.data.data && res.data.data.responses){

                console.log('res.data.data.responses --- ', res.data.data.responses)
              
                let allResponses = res.data.data.responses.map(x => ({
                  question_id: x.question_id,
                  selectedAnswer: x.selected_answers[0],
                  question_type: x.question_type,
                  question: quizData.questions.find(
                    y => y.question_id == x.question_id
                  ),
                }));
      
                console.log(allResponses);
      
                updateTriviaResponses(allResponses)
              }

              //resetTrivia();
              // const urlCondq = !isOpenQuiz
              //   ? url.writeCurrentTriviaTopScores
              //   : url.writeCurrentTriviaTopScoresPublic;
              // axios
              //   .post(urlCondq, {
              //     triviaId: quizData._id,
              //   })
              //   .then(res => {
              //     console.log("Top scores updated successfully");
              //   })
              //   .catch(err => {
              //     console.log("Error while writing top scores");
              //   });
            });
        }

        // if (quizData.ratingPage && quizData.ratingPage.display) {
        //   setCurrentQuestion("RATING");
        //   if (!demoPreview) {
        //     props.history.push("rating");
        //   }
        // } else {
          if (!demoPreview) {
            props.history.push({
              pathname: "result",
              search: `?resultId=${quizResultObjectId}`,
            });
          }
          setCurrentQuestion("ENDING");
        // }
    
      } else {
        const doc = quizData.questions[index];
        if (!demoPreview) {
          props.history.push(doc.question_id);
        }

        setCurrentQuestion(doc);
      }
    }
  };

  const selectAnswer = async(question, answer, time, type) => {
    const prevResponses = [...triviaResponses];
    const extIdx = prevResponses.findIndex(
      x => x.question_id == question.question_id
    );

    const isLastQuestion =
    quizData && quizData.questions && question
      ? quizData.questions.findIndex(
          x => x.question_id == question.question_id
        ) ==
        quizData.questions.length - 1
      : false;

    if (extIdx >= 0) {
      prevResponses[extIdx] = {
        ...prevResponses[extIdx],
        question_id: question.question_id,
        question,
        selectedAnswer: answer == null ? null : typeof answer == "object" ? answer : { text: answer },
        timeTaken: time,
        question_type: type,
      };
    } else {
      prevResponses.push({
        question_id: question.question_id,
        question,
        selectedAnswer: answer == null ? null : typeof answer == "object" ? answer : { text: answer },
        timeTaken: time,
        question_type: type,
      });

     
    }

    updateTriviaResponses(prevResponses);

    if(isLastQuestion){
      setTimeout(() => {
        jumpToNextStep(question.currentIndex+1,prevResponses)

        return true
      }, 1000);
      
    }

  };

  const getSelectedAnswer = question => {
    const prevResponses = [...triviaResponses];
    const extData = prevResponses.find(
      x => x.question_id == question.question_id
    );

    if (extData) {
      return extData.selectedAnswer;
    } else {
      return null;
    }
  };

  const shareUrl = `${baseUrl()}home/trivia/${
    !demoPreview
      ? props.match.params.orgId
      : props.user.profile.organizationId._id
  }/quiz/${surveyId}/start`;

  const leaveRatingPage = () => {
    setCurrentQuestion("ENDING");
    if (!demoPreview) {
      props.history.push({
        pathname: "result",
        search: `?resultId=${quizResultObjectId}`,
      });
    }
  };

  const holidayTemplateName =
    quizData &&
    quizData.generatedFromTemplate &&
    quizData.generatedFromTemplate.name
      ? quizData.generatedFromTemplate.name
      : "";

  if (autoStarting || (isMessaging && loading)) {
    // Show loading while auto-starting the quiz for logged-in users, or while data is loading for messaging trivvys
    return (
      <div className={previewOnly ? "isPreview" : ""}>
        <ReactTooltip />
        <div
          className="trivia_quiz_questions_ui_wrapper"
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            flexDirection: "column",
          }}
        >
          <div className="text-center">
            <div>
              <img src="/asserts/loading.gif" width={48} />
            </div>
            <p className="mt-2">Loading...</p>
          </div>
        </div>
      </div>
    );
  }

  if (quizData && currentQuestion) {
    const themeSettings =
      currentQuestion || quizData
        ? getThemeSettingsForPage(quizData, currentQuestion)
        : THEME_SETTING;

    const fileName = getTriviaFileName(quizData);

    const applyCustomThemeSettings = () => {
      if (
        themeSettings &&
        (themeSettings.quizBackgroundColor || themeSettings.quizTextColor)
      ) {
        return true;
      }
      return false;
    };

    return (
      <div className={previewOnly ? "isPreview" : ""}

      >
        {/* {isOpenQuiz.toString()} */}

        <ReactTooltip />
        <div
          className={
            currentQuestion == "WELCOME"
              ? "quiz_welcome_wrapper"
              : currentQuestion == "ENDING"
              ? `trivia_quiz_questions_ui_wrapper_2 ${
                  applyCustomThemeSettings() &&
                  themeSettings.quizBackgroundColor
                    ? ""
                    : "trivia-end-block-css"
                } `
              : currentQuestion == "RATING"
              ? "trivia_quiz_questions_ui_wrapper_2"
              : "trivia_quiz_questions_ui_wrapper"
          }
          style={{
            backgroundColor: themeSettings.quizBackgroundColor,
            color: themeSettings.quizTextColor,
            ...(isOpenQuiz && {
              top: "0px",
              height: "100vh",
              overflowY: "auto",
              position: "relative",
              display: "block",
            }),
            // overflowX:"hidden"
          }}
        >
          {currentQuestion === "WELCOME" ? (
            <div>
              <SurveyWelcomeBlock
               setCurrentQuestion={setCurrentQuestion}
               isMessaging={isMessaging}
                trivvy={quizData}
                triviaGenerationType={quizData.triviaType}
                welcomeData={quizData.welcomePage}
                themeSettings={themeSettings}
                jumpToNextStep={ind => {
                  jumpToNextStep(ind);
                }}
                categoryType={quizData.triviaCategoryType}
                fileName={fileName}
                uploadUrl={quizData.uploadUrl}
                quizName={quizData.name}
                updateQuizextUserEmail={email => {
                  setCurrentQuizExternalUserdata({ email: email });
                }}
                updateQuizextUserName={name => {
                  setCurrentQuizExternalUserdata({ name });
                }}
                updateQuizextUserEmployeeId={employeeId => {
                  setCurrentQuizExternalUserdata({ employeeId: employeeId });
                }}
                updateQuizextUserMobile={mobileNumber => {
                  setCurrentQuizExternalUserdata({ mobileNumber: mobileNumber });
                }}
                updateQuizextUserFirstName={firstName => {
                  setCurrentQuizExternalUserdata({ firstName: firstName });
                }}
                updateQuizextUserLastName={lastName => {
                  setCurrentQuizExternalUserdata({ lastName: lastName });
                }}
                
                isOpenQuiz={isOpenQuiz}
                quizExternalUserData={quizExternalUserData}
                noOfQuestions={quizData && quizData.questions.length}
                noOfMCQs={
                  quizData &&
                  quizData.questions.filter(x => x.question_type == "MCQ")
                    .length
                }
                isMobileView={isMobileView}
                demoPreview={demoPreview}
                totalQuizSeconds={totalQuizSeconds}
                currentQuizLinkedRewards={currentQuizLinkedRewards}
                quizEndDate={quizData && quizData.trivvyEndDate}
                endDateDue={endDateDue}
                startButtonLoading={startButtonLoading}
                updateQuizAnonymous={val => {
                  setCurrentQuiz({ ...quizData, isAnonymous: val });
                }}
                quizSubmitAnonymous={quizData && quizData.isAnonymous==false? true: false}
                showAnonymousToggle={quizData.allowAnonymousResponses}
                timedQuestionsEnable={quizData && quizData.timedQuestionsEnable}
                minimumPassingPercent={
                  quizData &&
                  quizData.minimumPassingPercent != null &&
                  quizData.minimumPassingPercent > 0
                    ? quizData.minimumPassingPercent
                    : 0
                }
                userIdentificationOptions={
                  quizData.userIdentificationOptions &&
                  quizData.userIdentificationOptions.length > 0
                    ? quizData.userIdentificationOptions
                    : ["EMAIL"]
                }
                uploadText={quizData.uploadText}
                templateType={quizData.templateType}
                customTemplateData={quizData.customTemplateData}
                holidayTemplateName={holidayTemplateName}
                isMixedTimedMcqTrivvy={isMixedTimedMcqTrivvy}
                librarySummaryText={quizData.librarySummaryText}
                trivvyLanguage={quizData.trivvyLanguage}
              />
              {isMobileView && demoPreview && (
                <div
                  className="text-center"
                  style={{
                    position: demoPreview ? "relative" : "fixed",
                    bottom: isOpenQuiz ? "0px" : "0px",
                    backgroundColor: themeSettings.quizBackgroundColor,
                    width: "100%",
                    zIndex: 9999999,
                  }}
                >
                  <div
                    style={{
                      paddingBottom: "10px",
                      paddingTop: "10px",
                      width: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.07)",
                    }}
                  >
                    {/* <div
                      style={{
                        color: themeSettings.quizTextColor,
                        fontSize: "0.94em",
                      }}
                      className="mb-2"
                    >
                      <AiFillClockCircle className="mr-1" />{" "}
                      {totalQuizSeconds == 0 ? (
                        "Not timed"
                      ) : (
                        <span>Takes {totalQuizSeconds} seconds.</span>
                      )}
                    </div> */}
                    <Button
                      // className="trivia-action-button-media px-3 py-2"
                      onClick={() => jumpToNextStep(0)}
                      style={{
                        cursor: "pointer",
                        width: "100%",
                        ...(demoPreview &&{
                          fontSize:"17px"
                        })
                        
                      }}
                      color="success"
                      className="mt-2 trivia-action-button-main trivvy-start-btn-styles"
                    >
                      {quizData.welcomePage.buttonText}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          ) :currentQuestion === "MESSAGING"?
          <MessagingSurvey 
          isOpenQuiz={isOpenQuiz}
          orgId={props.match.params.orgId}
          
          />: currentQuestion === "ENDING" ? (
            <SurveyEndingBlock
            trivvyLanguage={quizData.trivvyLanguage}
              endingData={quizData.endingPage}
              themeSettings={themeSettings}
              quizExternalUserData={quizExternalUserData}
              setCurrentQuestion={setCurrentQuestion}
              setCurrentQuiz={setCurrentQuiz}
              quizResponses={triviaResponses}

              shareUrl={shareUrl}
              privacy={quizData.privacy}
              isMobileView={isMobileView}
              demoPreview={demoPreview}
              questions={quizData.questions}
              quizData={quizData}
              timeTaken={timeTaken}
              quizResultObjectId={quizResultObjectId}
              previewOnly={previewOnly}
              isLastAttempt={quizData.isLastAttempt}
              source={quizData.uploadUrl}
              customText={quizData.uploadText}
              currentQuizLinkedRewards={currentQuizLinkedRewards}
              {...props}
            />
          ) : currentQuestion === "RATING" ? (
            <TriviaRatingBlock
            trivvyLanguage={quizData.trivvyLanguage}
              themeSettings={quizData.themeSettingsRatingPage}
              setCurrentQuestion={setCurrentQuestion}
              setCurrentQuiz={setCurrentQuiz}
              isMobileView={isMobileView}
              demoPreview={demoPreview}
              quizData={quizData}
              quizResultObjectId={quizResultObjectId}
              previewOnly={previewOnly}
              customText={quizData.uploadText}
              setTrivvyRatingSubmitted={setTrivvyRatingSubmitted}
              ratingSubmitted={ratingSubmitted}
              leaveRatingPage={leaveRatingPage}
              {...props}
            />
          ) : (
            <SurveyQuestionsBlock
            trivvyLanguage={quizData.trivvyLanguage}
              totalQuizSeconds={totalQuizSeconds}
              question={currentQuestion}
              themeSettings={themeSettings}
              jumpToNextStep={jumpToNextStep}
              currentIndex={quizData.questions.findIndex(
                x => x.question_id == currentQuestion.question_id
              )}
              selectAnswer={selectAnswer}
              selectedAnswer={getSelectedAnswer(currentQuestion)}
              noOfQuestions={quizData && quizData.questions.length}
              noOfMCQs={
                quizData &&
                quizData.questions.filter(x => x.question_type == "MCQ").length
              }
              isMobileView={isMobileView}
              demoPreview={demoPreview}
              quizData={quizData}
              hideTimer={
                previewOnly || demoPreview
                //isTrivvyGeneratedFromCustomTemplates(quizData)
              }
              isOpenQuiz={isOpenQuiz}
              previewOnly={previewOnly}
            />
          )}

          {quizData && (previewOnly || demoPreview) && (
            <div
              className={currentQuestion ==="WELCOME"? "share-demo-preview-ctrl-container welcomePageButtons" : "share-demo-preview-ctrl-container"}
              style={{
                ...(previewOnly && {
                  position: "fixed",
           
                  left: isMobile || isMobileView ? "10px" : "0px",
                }),

                ...(demoPreview && {
                  position: "absolute",
                  bottom: isMobile ? "100px" : "0px",
                 
                  ...(isMobileView ? {
                   
                    
                    ...(currentQuestion !=="WELCOME"? { }:{bottom:"60px",padding:0,})
                   
                  }:{
                    padding:"5px",
                    left: isMobile ? "10px" :isMobileView ? "" : "1em",
                  }),
                
                }),
              }}
            >
              {!demoPreview && (
                <Button
                  onClick={togglePreview}
                  color="danger"
                  // className="trivia-preview-exit-button"
                >
                  {" "}
                  Close
                  <BiX
                    size={21}
                    className="cursor-pointer "
                    data-tip={"Exit preview"}
                  />
                </Button>
              )}

              {currentQuestion != "WELCOME" && (
                <Button
                  className="ml-2"
                  onClick={() => {
                    let currentQuestionIndex = 0;

                    if (
                      currentQuestion != "WELCOME" &&
                      currentQuestion != "ENDING" &&
                      currentQuestion != "RATING" &&
                      currentQuestion.question_id
                    ) {
                      const index = quizData.questions.findIndex(
                        x => x.question_id == currentQuestion.question_id
                      );

                      currentQuestionIndex = index - 1;
                      if (currentQuestionIndex == -1) {
                        setCurrentQuestion("WELCOME");
                      } else {
                        setCurrentQuestion(
                          quizData.questions[currentQuestionIndex]
                        );
                      }
                    }

                    if (currentQuestion == "ENDING") {
                      if (quizData.ratingPage && quizData.ratingPage.display) {
                        setCurrentQuestion("RATING");
                      } else {
                        const lastQ =
                          quizData.questions[quizData.questions.length - 1];
                        setCurrentQuestion(lastQ);
                      }
                    }
                    if (currentQuestion == "RATING") {
                      const lastQ =
                        quizData.questions[quizData.questions.length - 1];
                      setCurrentQuestion(lastQ);
                    }
                  }}
                >
                  {" "}
                  <BiSkipPrevious /> Back{" "}
                </Button>
              )}

              {currentQuestion !== "ENDING" ? (
                <Button
                  onClick={() => {
                    let currentQuestionIndex = 0;

                    if (
                      currentQuestion != "WELCOME" &&
                      currentQuestion != "ENDING" &&
                      currentQuestion != "RATING" &&
                      currentQuestion.question_id
                    ) {
                      const index = quizData.questions.findIndex(
                        x => x.question_id == currentQuestion.question_id
                      );

                      currentQuestionIndex = index + 1;
                    }

                    if (currentQuestion == "RATING") {
                      setTrivvyRatingSubmitted(true);
                      setCurrentQuestion("ENDING");
                      return;
                    }

                    if (currentQuestion == "ENDING" && !ratingSubmitted) {
                      setTrivvyRatingSubmitted(true);
                    } else {
                      if (currentQuestionIndex >= 0) {
                        jumpToNextStep(currentQuestionIndex);
                      }
                    }
                  }}
                  color="info"
                  className="ml-2 trivvy-preview-btn-next"
                >
                  {" "}
                  Next
                  <BiSkipNext />
                </Button>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </div>
    );
  } else {
    if (!loading) {
      return (
        <div>
          <div
            className="trivia_quiz_questions_ui_wrapper"
            style={{
              flexDirection: "column",
              backgroundColor: "white",
              ...(isOpenQuiz
                ? {
                    top: "0px",
                  }
                : {
                    top: "20px",
                  }),
            }}
          >
            <EmptyTable
              // title={apiErrorMessage || "No trivvy found"}
              // subtitle={
              //   "We're Sorry. Looks like this trivvy link is either invalid or restricted. Please contact your Admin."
              // }
              customImage={apiErrorImage}
              customStyles={
                isMobile
                  ? {
                      width: "90%",
                      height: "200px",
                    }
                  : {
                      height: "400px",
                      width: "500px",
                    }
              }
            />
            <div className="text-center mt-5">
              <Button
                onClick={() => {
                  props.history.push(`/home`);
                }}
                className="trivia-action-button-main"
              >
                Login to take this Survey
              </Button>
            </div>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = state => {
  console.log(state, "state");
  return {
    user: state.user,
    quizData: state.trivia.currentQuizData,
    currentQuestion: state.trivia.currentQuestion,
    currentQuizQuestion: state.trivia.currentQuizQuestion,
    triviaResponses: state.trivia.triviaResponses,
    quizResultObjectId: state.trivia.quizResultObjectId,
    quizExternalUserData: state.trivia.quizExternalUserData,
    currentQuizLinkedRewards: state.trivia.currentQuizLinkedRewards,
    ratingSubmitted: state.trivia.ratingSubmitted,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: data => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentQuiz: data => dispatch(actionCreators.setCurrentQuiz(data)),
    setCurrentQuizQuestion: data =>
      dispatch(actionCreators.setCurrentQuizQuestion(data)),
    setCurrentQuestion: data =>
      dispatch(actionCreators.setCurrentQuestion(data)),
    updateTriviaResponses: data =>
      dispatch(actionCreators.updateTriviaResponses(data)),
    resetTrivia: () => dispatch(actionCreators.resetTrivia()),
    setCurrentQuizResultObjectId: data =>
      dispatch(actionCreators.setCurrentQuizResultObjectId(data)),
    setCurrentQuizExternalUserdata: data =>
      dispatch(actionCreators.setCurrentQuizExternalUserdata(data)),
    setCurrentQuizLinkedRewards: data =>
      dispatch(actionCreators.setCurrentQuizLinkedRewards(data)),
    setTrivvyRatingSubmitted: data =>
      dispatch(actionCreators.setTrivvyRatingSubmitted(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TriviaQuizUI);
